import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "../Components/BrandLogo";
import "./Homepage.css";

const Arrow = () => (
  <svg className="arrow" viewBox="0 0 14 14" fill="none">
    <path d="M1 7h12M9 3l4 4-4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const MarqueeRow = () => (
  <div className="df-marquee-track">
    {Array.from({ length: 2 }).map((_, k) => (
      <React.Fragment key={k}>
        <span>Infinite</span>
        <span className="dot" />
        <span className="accent">Creative</span>
        <span className="dot" />
        <span>Ideas</span>
        <span className="dot" />
        <span className="accent">Strategy</span>
        <span className="dot" />
        <span>Design</span>
        <span className="dot" />
        <span className="accent">Story</span>
        <span className="dot" />
      </React.Fragment>
    ))}
  </div>
);

export const Homepage = () => {
  return (
    <div className="df-root">
      {/* ───────────────  NAV  ─────────────── */}
      <nav className="df-nav">
        <BrandLogo variant="full" size={40} />
        <div className="df-nav-right">
          <a className="df-nav-link" href="#work">Work</a>
          <a className="df-nav-link" href="#studio">Studio</a>
          <a className="df-nav-link" href="#approach">Approach</a>
          <Link to="/login" className="df-btn df-btn-ghost">
            Sign In
          </Link>
        </div>
      </nav>

      {/* ───────────────  HERO  ─────────────── */}
      <section className="df-hero">
        <div>
          <div className="df-eyebrow">Independent design studio · Est. 2018</div>

          <h1>
            Crafting <em>infinite</em><br />
            ideas with<br />
            <span className="small">creative precision.</span>
          </h1>

          <p className="df-lede">
            A workspace built for the way modern studios actually work — projects, tasks,
            chat, files, attendance and analytics in one quietly considered place.
          </p>

          <div className="df-cta-row">
            <Link to="/login" className="df-btn">
              Enter Workspace <Arrow />
            </Link>
            <a href="#approach" className="df-btn df-btn-ghost">
              Our Approach
            </a>
          </div>
        </div>

        <aside className="df-hero-aside">
          <div className="df-composition">
            <div className="block b1" />
            <div className="block b2" />
            <div className="block b3" />
            <div className="block b4" />
            <span className="label">— Fig. 01 / Studio Composition</span>
          </div>
        </aside>
      </section>

      {/* ───────────────  MARQUEE  ─────────────── */}
      <div className="df-marquee">
        <MarqueeRow />
      </div>

      {/* ───────────────  PILLARS  ─────────────── */}
      <section className="df-pillars" id="approach">
        <div>
          <div className="df-section-label">
            <span className="num">02</span>
            What lives here
          </div>
          <h2
            style={{
              fontFamily: "'Familjen Grotesk', 'Montserrat', sans-serif",
              fontWeight: 900,
              fontSize: 44,
              letterSpacing: "-0.03em",
              lineHeight: 1.02,
              marginTop: 28,
              textTransform: "uppercase",
            }}
          >
            One quiet platform.<br />
            {/* 44px/900 is WCAG "large text", so brand red (4.53:1 on white) clears the 3:1 bar. */}
            <em style={{ fontStyle: "normal", fontWeight: 900, color: "var(--accent)" }}>
              Every moving part.
            </em>
          </h2>
        </div>

        <div className="df-pillars-grid">
          <div className="df-pillar">
            <div className="num">— 01</div>
            <h3>Projects &amp; <em>tasks</em></h3>
            <p>Kanban boards, deadlines, departments and event-sourced lifecycle tracking that actually surfaces the slow things.</p>
          </div>
          <div className="df-pillar">
            <div className="num">— 02</div>
            <h3>Chat that <em>thinks</em></h3>
            <p>Project channels, DMs, threads, polls, attachments, link previews and a quiet notification system that respects focus.</p>
          </div>
          <div className="df-pillar">
            <div className="num">— 03</div>
            <h3>People &amp; <em>HR</em></h3>
            <p>Attendance, leaves, holidays, performance and notices — the operational layer that keeps the studio running.</p>
          </div>
          <div className="df-pillar">
            <div className="num">— 04</div>
            <h3>Operational <em>analytics</em></h3>
            <p>Efficiency factors, time tracking, where work stalls and where it flies. Numbers that lead to better creative decisions.</p>
          </div>
        </div>
      </section>

      {/* ───────────────  FOOTER  ─────────────── */}
      <footer className="df-foot">
        <BrandLogo variant="lockup" size={36} />
        <div className="df-foot-meta">
          <span>© {new Date().getFullYear()} Quantiv Media</span>
          <span>India · Global</span>
          <span>v.1</span>
        </div>
      </footer>
    </div>
  );
};

export default Homepage;
